import React, { Component } from "react";
import axios from "axios";

class BlueButtonRecordsViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      src: props.src ? props.src : "",
      isExist: false,
      isLoading: true,
      fileName: "",
      patientId: "",
    };
  }

  fetchFile = async () => {
    try {
      let token = localStorage.getItem("login_token");
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };
      let patientId =
        (sessionStorage.getItem("patient") &&
          JSON.parse(sessionStorage.getItem("patient")).id) ||
        "";
      if (patientId === "") {
        const pDoc = sessionStorage.getItem("pDoc") &&
          JSON.parse(sessionStorage.getItem("pDoc"));
        patientId = (pDoc && (pDoc.patientId || pDoc.patient)) || "";
      }

      const res = await axios
        .post(`${process.env.API_URL}/patients/get-blue-button-records-file`,
          { patientId: patientId },
          { headers });

      const fileName = res.data.fileName;

      const response = await fetch(`${process.env.API_URL}/file/${fileName}`, {
          method: 'GET',
          headers,
      });

      if (!response.ok) throw new Error("Failed to fetch PDF");

      const blob = await response.blob();
      const fileUrl = URL.createObjectURL(blob);

      this.setState({ isExist: true, patientId: patientId, fileName: fileName, pdfObjectUrl: fileUrl })

    } catch (error) {
        this.setState({ isExist: false, pdfObjectUrl: false })
        console.error("PDF Fetch Error:", error);
    } finally {
        this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
      this.fetchFile();
  }

  componentWillUnmount() {
      if (this.state.pdfObjectUrl) {
          URL.revokeObjectURL(this.state.pdfObjectUrl);
      }
  }

  render() {
    const { onClose } = this.props;

    return (
      <div
        className="overlay-msg"
        onClick={(e) => {
          onClose(e);
        }}
      >
        <div className="overlay-box">
          <div className="row">
            {this.state.isLoading ? (
              <div style={{ color: "#F12F39" }}>
                <h1>Loading file ...</h1>
              </div>
            ) : this.state.isExist ? (
              <iframe
                width="100%"
                height="700"
                src={this.state.pdfObjectUrl}
                type="application/pdf"
                title="blue button records"
              ></iframe>
            ) : (
              <div style={{ color: "#F12F39" }}>
                <h1>Blue Button Records are not available</h1>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default BlueButtonRecordsViewer;
